import React from 'react';
import { Link } from 'react-router-dom';
import Watermark from '../Watermark/Watermark';
import judcoco from '../../assets/images/ju1.png';
import fnaf1 from '../../assets/images/fnaf1.png';
import fnaf2 from '../../assets/images/fnaf2.png';
import fnaf3 from '../../assets/images/fnaf3.png';
import fnaf4 from '../../assets/images/fnaf4.png';
import './Home.scss';
import SEO from '../SEO/SEO';

function Home() {
  const preventRightClick = (e) => {
    e.preventDefault();
    alert("Ces emotes sont protégées. Merci de ne pas essayer de les télécharger.");
  };

  const preventDragStart = (e) => {
    e.preventDefault();
  };

  const watermarkOptions = {
    text: 'Judcoco',
    textColor: 'rgba(255, 255, 255, 0.5)',
    fontSize: '20px',
    opacity: 0.5
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      <SEO 
        title="Judcoco | Créations d'Emotes Personnalisées"
        description="Créatrice d'emotes personnalisées pour Twitch, Discord, Tiktok et YouTube. Donnez vie à votre chaîne avec des emotes uniques et professionnelles."
        pathname="/"
        keywords="emotes twitch, emotes discord, emotes personnalisées, badges twitch, création emotes, dessin emotes, emotes streamer, emotes stream, artiste emotes, design emotes, emotes sur mesure, emotes chibi, emotes kawaii"
      />

      <div className="home">
        {/* Section Hero */}
        <section className="hero">
          <div className="hero-content">
            <h1>Créations d'Emotes Personnalisées</h1>
            <p>Des emotes uniques pour votre chaîne Twitch, Discord et YouTube</p>
            <div className="hero-buttons">
              <Link to="/gallery" className="btn btn-primary" onClick={scrollToTop}>Voir la Galerie</Link>
              <Link to="/commission" className="btn btn-secondary" onClick={scrollToTop}>Commander</Link>
            </div>
          </div>
          <div className="hero-image" onContextMenu={preventRightClick}>
            <Watermark 
              text={watermarkOptions.text}
              textColor={watermarkOptions.textColor}
              fontSize={watermarkOptions.fontSize}
              opacity={watermarkOptions.opacity}
            >
              <img 
                src={judcoco} 
                alt="emote de judcoco" 
                onDragStart={preventDragStart}
              />
            </Watermark>
          </div>
        </section>

        {/* Section Services */}
        <section className="services">
          <h2>Mes Services</h2>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">🎮</div>
              <h3>Emotes Twitch</h3>
              <p>Donnez vie à votre chaîne avec des emotes personnalisées</p>
            </div>
            <div className="service-card">
              <div className="service-icon">💬</div>
              <h3>Emotes Discord</h3>
              <p>Enrichissez votre serveur avec des emotes uniques</p>
            </div>
            <div className="service-card">
              <div className="service-icon">📱</div>
              <h3>Emotes Tiktok</h3>
              <p>Personnalisez vos contenus avec des emotes originales</p>
            </div>
            <div className="service-card">
              <div className="service-icon">🎥</div>
              <h3>Emotes YouTube</h3>
              <p>Ajoutez une touche unique à votre chaîne</p>
            </div>
          </div>
        </section>

        {/* Section Derniers Travaux */}
        <section className="recent-works">
          <h2>Dernières Créations</h2>
          <div className="works-grid">
            {[
              { id: 1, img: fnaf1 },
              { id: 2, img: fnaf2 },
              { id: 3, img: fnaf3 },
              { id: 4, img: fnaf4 },
            ].map((item) => (
              <div key={item.id} className="work-item" onContextMenu={preventRightClick}>
                <Watermark 
                  text={watermarkOptions.text}
                  textColor={watermarkOptions.textColor}
                  fontSize={watermarkOptions.fontSize}
                  opacity={watermarkOptions.opacity}
                >
                  <img 
                    src={item.img} 
                    alt={`Emote ${item.id}`} 
                    onDragStart={preventDragStart}
                  />
                </Watermark>
              </div>
            ))}
          </div>
          <Link to="/gallery" className="btn btn-outline" onClick={scrollToTop}>Voir plus</Link>
        </section>

        {/* Section Processus */}
        <section className="process">
          <h2>Comment ça marche ?</h2>
          <div className="process-steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Discussion</h3>
              <p>Échangeons sur votre projet et vos besoins</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>Croquis</h3>
              <p>Je réalise une première ébauche pour validation</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>Création</h3>
              <p>Je finalise votre commande avec soin</p>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <h3>Livraison</h3>
              <p>Vous recevez vos emotes prêtes à l'emploi</p>
            </div>
          </div>
        </section>

        {/* Section Témoignages */}
        {/* <section className="testimonials">
          <h2>Ils me font confiance</h2>
          <div className="testimonials-slider">
            <div className="testimonial">
              <p>"Des emotes incroyables qui ont donné vie à ma chaîne !"</p>
              <div className="testimonial-author">
                <Watermark 
                  text={watermarkOptions.text}
                  textColor={watermarkOptions.textColor}
                  fontSize={watermarkOptions.fontSize}
                  opacity={watermarkOptions.opacity}
                >
                  <img 
                    src="/images/streamer1.png" 
                    alt="Streamer 1" 
                    onDragStart={preventDragStart}
                  />
                </Watermark>
                <div>
                  <h4>NomStreamer</h4>
                  <span>Streamer Twitch</span>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        {/* Section CTA */}
        <section className="cta">
          <h2>Prêt à donner vie à vos idées ?</h2>
          <p>Contactez-moi pour discuter de votre projet</p>
          <Link to="/contact" className="btn btn-primary" onClick={scrollToTop}>Commencer</Link>
        </section>

        {/* Section Status */}
        <div className="commission-status">
          <div className="status-indicator open">
            <span className="status-dot"></span>
            Commissions ouvertes
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;